import { useContext } from 'react';

import { ElectronicFenceContext } from '../contexts/electronic-fence';

export function useElectronicFence() {
    return useContext(ElectronicFenceContext);
}
